// ORDER_STATUS
export const AWAITING_PAYMENT = 'awaiting-payment';
export const AWAITING_SHIPMENT = 'awaiting-shipment';
export const CANCELLED = 'cancelled';
export const ON_HOLD = 'on-hold';
export const PENDING_FULFILLMENT = 'pending-fulfillment';
export const REJECTED_FULFILLMENT = 'rejected-fulfillment';
export const SHIPPED = 'shipped';
